import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Phone, Mail, MapPin } from "lucide-react";
import { api } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll get back within 24 hours.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="fade-in max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16 grid md:grid-cols-5 gap-10">
      <div className="md:col-span-2">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF9933] font-bold mb-2">Contact</div>
        <h1 className="serif text-4xl md:text-5xl font-semibold text-[#000080] leading-tight mb-5">Let's talk.</h1>
        <p className="text-[#4A4A4A] mb-8">Whether you want to donate, volunteer, partner on CSR, or just say hello — we'd love to hear from you.</p>
        <div className="space-y-4">
          <InfoRow icon={Phone} label="Phone" value="+91 8002485087 / 7762864168" />
          <InfoRow icon={Mail} label="Email" value="Support@adopthelplesschildren.com" />
          <InfoRow icon={MapPin} label="Bank" value="SBI A/C 44703110576 · IFSC SBIN0018600" />
        </div>
      </div>
      <form onSubmit={submit} className="md:col-span-3 bg-white rounded-3xl border border-[#eae5d9] p-8" data-testid="contact-form">
        <div className="grid md:grid-cols-2 gap-4">
          <Input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
          <Input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
          <Input placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
          <Input required placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" />
          <Textarea required placeholder="Your message..." value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="md:col-span-2 min-h-[140px]" data-testid="contact-message" />
          <Button type="submit" disabled={loading} className="md:col-span-2 bg-[#FF9933] hover:bg-[#E68A2E] text-white h-12 rounded-full btn-glow" data-testid="contact-submit">
            {loading ? "Sending..." : "Send Message"}
          </Button>
        </div>
      </form>
    </div>
  );
}

function InfoRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-10 h-10 rounded-full bg-[#FF9933]/15 flex items-center justify-center shrink-0">
        <Icon className="w-4 h-4 text-[#FF9933]" strokeWidth={1.8} />
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider text-[#737373]">{label}</div>
        <div className="text-sm font-semibold text-[#000080]">{value}</div>
      </div>
    </div>
  );
}
